import { useI18n } from '@hive/i18n';
import type { FC } from 'react';

import { Button } from '../../ui/button';
import { AuthPageContainer } from './auth-page-container';

export const SignInSuccessPage: FC<{
  onOpenHive: () => void;
}> = ({ onOpenHive }) => {
  const t = useI18n();
  return (
    <AuthPageContainer
      title={t['com.hive.auth.signed.success.title']()}
      subtitle={t['com.hive.auth.signed.success.subtitle']()}
    >
      <Button variant="primary" size="large" onClick={onOpenHive}>
        {t['com.hive.auth.open.hive']()}
      </Button>
    </AuthPageContainer>
  );
};
